// extracted by mini-css-extract-plugin
export default {"weekTab":"style_weekTab__YLx7H"};